module.exports = __webpack_public_path__ + "5be3681a2c57d12a6c5dfaf5655c56f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/accenture_2022_chart.png
// module id = 1620
// module chunks = 0